import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="auto-submit-form"
export default class extends Controller {
  submit() {
    this.element.submit()
  }
}
